import * as exclusiveConst from './constants';
import * as commonRegionService from '../../services/common/region';
import _ from 'lodash';

export default {
    [exclusiveConst.getExclusives](state, list) {
        state.list = list.DedicatedHostSet;
    },
    [exclusiveConst.ExclusiveSystem](state, data) {
        // state.exclusiveSystem = data;
        state.exclusiveSystem = data.data;
        state.soldoutList = data.sellOutData;
    },
    [exclusiveConst.queryExclusive](state, data) {
        _.forEach(data, (v, k) => {
            state[k] = v;
        });
        commonRegionService.setRegion(data.AviodRegionNow);
    },
    [exclusiveConst.QueryBillTypeByDedicatedIds](state, data) {
        state.exclusiveBill = data.exclusiveBill
        state.exclusiveDiscount = data.exclusiveDiscount
    },
    [exclusiveConst.getDedicatedCluster](state, data) {
        state.clusterlist = data.DedicatedClustersSet;
    },

    [exclusiveConst.DescribeTagKeysV2](state, data) {
        state.tagKeySetV2 = data;
    },
    [exclusiveConst.DescribeTagValuesV2](state, data) {
        state.tagValueSetV2 = data;
    },
    
    [exclusiveConst.exclusiveOverview](state, data) {
        let overviewlist = [];
        let totalexclusivenum=0,
            activenum=0,
            toexpirenum=0,
            expirednum=0,
            othernum=0,
            dr1num=0,
            dc1num=0,
            dc2num=0,
            ds2num=0,
            dn2num=0,
            ag1num=0,
            dr3num=0,
            ds3num=0,
            ds6num=0;
        _.forEach(data.ResourceList,(item) =>{
            let oitem={}
            oitem = _.values(item)[0];
            oitem.region = _.keys(item)[0];
            totalexclusivenum += (oitem.DedicatedCount || 0);
            activenum += (oitem.Active || 0);
            toexpirenum += (oitem.AboutToExpired || 0);
            expirednum +=(oitem.Expired || 0);
            othernum += oitem.Other;
            _.forEach(oitem.dedicatedTypeCount,citem=>{
                switch(citem.Value){
                    case 'DC1':
                        dc1num += citem.Count;break;
                    case 'DR1':
                        dr1num += citem.Count;break;
                    case 'DS2':
                        ds2num += citem.Count;break;
                    case 'DC2':
                        dc2num += citem.Count;break;
                    case 'DN2':
                        dn2num += citem.Count;break;
                    case 'AG1':
                        ag1num += citem.Count;break;
                    case 'DR3':
                        dr3num += citem.Count;break;
                    case 'DS3':
                        ds3num += citem.Count;break;
                    case 'DS6':
                        ds6num += citem.Count;break;
                }
            })
            overviewlist.push(oitem)
        })
        state.OverViewList = overviewlist;
        state.TotalExclusivenum = totalexclusivenum;
        state.Activenum = activenum;
        state.Toexpirenum = toexpirenum;
        state.Expirednum = expirednum;
        state.Othernum = othernum;
        state.dr1num = dr1num,
        state.dc1num = dc1num,
        state.dc2num = dc2num,
        state.ds2num = ds2num,
        state.dn2num = dn2num;
        state.ag1num = ag1num;
        state.dr3num = dr3num;
        state.ds3num = ds3num;
        state.ds6num = ds6num;
    },

}
